import { Koi } from '@ksyos/koi';

export interface ILabResult {
    codeCode: string;
    codeDisplayName: string;
    codeSystem: string;
    codeSystemName: string;
    codeSystemVersion: string;
    comment: string;
    endDate: string | null;
    id: string;
    startDate: string | null;
    valueCode: string;
    valueCodeSystem: string;
    valueDisplayName: string;
    valueSystemVersion: string;
    valueType: string;
    valueUnit: string;
    valueValue: string;
}

export const labResultSchema = Koi.object({
    codeCode: Koi.string().max(255).allow('', null),
    codeDisplayName: Koi.string().max(255).allow('', null),
    codeSystem: Koi.string().max(255).allow('', null),
    codeSystemName: Koi.string().max(255).allow('', null),
    codeSystemVersion: Koi.string().max(255).allow('', null),
    comment: Koi.string().max(255).allow('', null),
    endDate: Koi.koi().endDate().allow('', null),
    id: Koi.string().max(255).allow('', null),
    startDate: Koi.koi().date().allow('', null),
    valueCode: Koi.string().max(255).allow('', null),
    valueCodeSystem: Koi.string().max(255).allow('', null),
    valueDisplayName: Koi.string().max(255).allow('', null),
    valueSystemVersion: Koi.string().max(255).allow('', null),
    valueType: Koi.string().max(255).allow('', null),
    valueUnit: Koi.string().max(255).allow('', null),
    valueValue: Koi.string().max(255).allow('', null),
});

export const labResultDraftAddSchema = Koi.object({
    codeDisplayName: Koi.string().max(255).allow('', null),
    id: Koi.string(),
    startDate: Koi.koi().date().allow('', null),
    valueUnit: Koi.string().max(255).allow('', null),
    valueValue: Koi.string().max(255).allow('', null),
});

export const LabResultFinalAddSchema = Koi.object({
    codeDisplayName: Koi.string().max(255).required(),
    id: Koi.string().required(),
    startDate: Koi.koi().date().required(),
    valueUnit: Koi.string().max(255).required(),
    valueValue: Koi.string().max(255).required(),
});

export type ILabResults = ILabResult[];

export const labResults = Koi.array().items(labResultSchema);

export interface ISsoLabResult {
    description: string;
    start: string;
    unit: string;
    value: string;
}

const ssoLabResult = Koi.object({
    description: Koi.string().max(255).allow(''),
    start: Koi.string().max(255).allow(''),
    unit: Koi.string().max(255).allow(''),
    value: Koi.string().max(255).allow(''),
});

export const ssoLabResults = Koi.array().items(ssoLabResult);
